import React, {useEffect } from 'react';
import useState from 'react-usestateref';
import '../index.css'; // Create a CSS file for styling if needed
import {
 fetchListConnections,deleteReports,listOfReports
} from '../authorization/FetchToken';
import Drawer from "@mui/material/Drawer";
import Navbar from '../components/Navbar';
import { useNavigate } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import Spinner from '../Spinner'; // Import the Spinner component
import {
  Typography,
  Box,
  Button,
  Alert,
  Grid,
  Stack
} from "@mui/material";
import Swal from 'sweetalert2';
import { useAuth } from './AuthContext';
import InfoTip from "../components/InfoTip";
import {IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ReactMarkdown from "react-markdown";

function ListConnectionPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [showCreateErrorMessage, setShowCreateErrorMessage] = useState(false);

  // Initialize state to store the list of connections
  const [connections, setConnections] = useState([]);
  const [backups, setBackups] = useState([]);
  const [reportsLength, setReportsLength] = useState([]);
  const [loading, setLoading] = useState(false);
  const [connectionDeleteName, setConnectionDeleteName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const [connectionType, setConnectionType] = useState('');
  const [connectionName, setConnectionName] = useState('');
  const [connectionDetails, setConnectionDetails] = useState('');
  const [connectionAllDetails, setConnectionAllDetails] = useState('');

  const [isEditing, setIsEditing] = useState(false);
  const [editFileName, setEditFileName] = useState('');


  const [showDeleteSuccessMessage, setShowDeleteSuccessMessage] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [backupConfig, setBackupConfig] = useState({
  name: '',
  database_path: '',
  storage_type: '',
  bucket: '',
  backup_path:'',
 }); 
 const [openDoc, setOpenDoc] = useState(false);
 const [doc, setDoc] = useState("");
 const [searchTerm, setSearchTerm] = useState('');
 const filteredConnections = connections.filter((c) =>
  c.name.toLowerCase().includes(searchTerm.toLowerCase())
);

const { userSessionRef} = useAuth();
const fetchListDataConnections = async () => {
    try {
      const orgName = userSessionRef.current["orgName"]
      console.log("orgName::11",userSessionRef.current)
      const connectionsData = await fetchListConnections("config","files",orgName);
      console.log('Connections Data:', connectionsData);

      let savedConnectionDetails = JSON.parse(localStorage.getItem('connectionDetails'));
      console.log(JSON.stringify(savedConnectionDetails)+"savedConnectionDetails");
      setConnectionDetails(savedConnectionDetails);
      console.log(JSON.stringify(connectionDetails)+"connectionDetails");

      // Check if savedConnectionDetails is not an array or null (empty)
      if (!Array.isArray(savedConnectionDetails) || !savedConnectionDetails) {
        // Initialize it as an empty array
        savedConnectionDetails = [];
      }
      if (Array.isArray(savedConnectionDetails)) {
          const connectionsWithTypes = connectionsData.map(connectionName => {
          const matchingConnection = savedConnectionDetails.find(conn => conn.connectionName === connectionName);
          const connectionType = matchingConnection ? matchingConnection.connectionType : '';
          console.log("connectionName::1",connectionName)
          const file_split = connectionName.split("/")
          return {
            name: file_split[1],
            feature: file_split[0],
          };
          /*
          return {
            name: connectionName,
            type: connectionType,
          };
          */
        });
        setConnections(connectionsWithTypes);
        if(location.state !== null){
          setConnectionAllDetails(location.state.connectionDetails);
        }
      
        listOfReportsLength(connectionsData);
  
      } else {
        console.error('savedConnectionDetails is not an array');
        // Handle the case where savedConnectionDetails is not an array, possibly setting a default value for connectionsWithTypes or other error handling logic.
      }

      // Do any additional processing or redirect as needed
    } catch (error) {
      console.error('Error fetching connections:', error);
    }
  };

  useEffect(() => {
    if (location.state && location.state.successMessage) {
      setShowSuccessMessage(true);
      setConnectionAllDetails(location.state.connectionDetails);
      // setConnections(location.state.connectionDetails);
      // setConnectionType(location.state.connectionType);
      // To retrieve the connection details from localStorage
 
      setTimeout(() => {
        setShowSuccessMessage(false);
        //navigate('/'); // Redirect back to the main page
      }, 3000); // Display for 3 seconds
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state && location.state.errorMessage) {
      setShowCreateErrorMessage(true);
      setTimeout(() => {
        setShowCreateErrorMessage(false);
        //navigate('/'); // Redirect back to the main page
      }, 3000); // Display for 3 seconds
    }
  }, [location.state]);

  useEffect(() => {
    if (connectionDeleteName) {
      setShowDeleteSuccessMessage(true);
      setTimeout(() => {
        setShowDeleteSuccessMessage(false);
        //navigate('/'); // Redirect back to the main page
      }, 3000); // Display for 3 seconds
    }
  }, [connectionDeleteName]);

  useEffect(() => {
    if (errorMessage) {
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
        //navigate('/'); // Redirect back to the main page
      }, 3000); // Display for 3 seconds
    }
  }, [errorMessage]);

  useEffect(() => {
    // Scroll to the top when loading is set to false
    if (!loading) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [loading]);


  const listOfReportsLength = async (connectionsData) => {
    const lengths = [];

    console.log('Connections Data:', connectionsData);

    if (connectionsData && connectionsData.length > 0) {
      for (const connectionName of connectionsData) {
        try {
          const listOfReportsData = await listOfReports(connectionName, userSessionRef.current["orgName"]);
          console.log(`List of reports data for ${connectionName}:`, listOfReportsData);

          if (listOfReportsData.length >= 0) {
            lengths.push(listOfReportsData.length);
            console.log('Lengths:', lengths);
          }
        } catch (error) {
          console.error(`Error fetching list of reports for ${connectionName}:`, error);
        }
      }
      setReportsLength(lengths);
    }

  };

  useEffect(() => {
    // Call the fetchConnections function when the component mounts
    fetchListDataConnections();

    console.log(JSON.stringify(connections) + "connections");
  }, []);


  // This function will be called when the "Create New Connection" button is clicked
  const handleCreateNewConnection = () => {
    navigate('/CreateNew', { state: connections });
  };

  // This function will be called when the form is submitted on the "CreateNewConnectionPage" component
  const handleSaveConnection = (formData) => {
    // Add the new connection data to the list of connections
    setConnections((prevConnections) => [...prevConnections, formData]);
  };

  
  const handleDelete = async (connectionName, stateType,fileObject, index) => {

    setLoading(true);
    try {
        const fileName = {
          "name": fileObject.feature + "/" + fileObject.name
        }
        const reportDeleteConnection = await deleteReports(connectionName, fileName,stateType, userSessionRef.current["orgName"]);
        const agentFileName = {
          "name": fileObject.name + "_" + "aiagent_config"
        }
        const reportDeleteAgent = await deleteReports("", agentFileName,"aiagent",userSessionRef.current["orgName"]);

        //console.log('Deleted Data:', deletedData);
        console.log('reportDeleteConnection Data:', reportDeleteConnection,reportDeleteAgent);
        //  update the connections state based on the response
        setConnections(prevConnections => prevConnections.filter((conn, i) => i !== index));
        console.log('reportDeleteConnection Data:22', reportDeleteConnection);
        setShowDeleteSuccessMessage(true); // Show the success message
        console.log('reportDeleteConnection Data:33', fileName);
        //window.location.reload();
        setConnectionDeleteName(fileName);
        console.log('reportDeleteConnection Data:44', reportDeleteConnection);

      } catch (error) {
        console.error('Error fetching connections:', error);
      }
      console.log('reportDeleteConnection Data:55');
      console.log('reportDeleteConnection Data:66');
      //fetchListDataConnections();
      setLoading(false);
      console.log('reportDeleteConnection Data:77');
      //setShowDeleteSuccessMessage(true);
      console.log('reportDeleteConnection Data:88');
      //window.location.reload();
  };
  

  const handleEditConnection = async (configName,configFeature) => {
    console.log('Navigating to EditConn page with connection:', configName,configFeature);
  
    navigate('/EditConn', { state: { configName: configName ,configFeature: configFeature} });
  };

  const handleReportDetails = (connection, index) => {
    console.log('Navigating to EditConn page with connection:', connectionName);
    
    navigate('/ReportDetails', { state: { connectionName: connection.name, connectionType: connection.type } });
  };

  const handleCreateNewBackup = () => {
    setBackupConfig({
      name: '',
      database_path: '',
      storage_type: 's3',
      access_key_id: '',
      secret_access_key: '',
      bucket: '',
      region: ''
    });
    setIsEditing(false);
    setEditFileName('');
    setShowModal(true);
  };

  return (
  <div className="main-container" style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}>

  <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
    <Box
      className="form-container"
      sx={{
        width: "100%",
        maxWidth: 2000,
        backgroundColor: "#ffffff",
        borderRadius: 3,
        border: "1px solid #e0e7ff",
        p: 4,
      }}
    >
      {/* Messages */}
      {showCreateErrorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          ERROR OCCURRED: {location.state.errorMessage}
        </Alert>
      )}
      {showErrorMessage && (
        <Alert severity="error" sx={{ mb: 2 }}>
          ERROR OCCURRED: {errorMessage}
        </Alert>
      )}
      {showDeleteSuccessMessage && (
        <Alert severity="success" sx={{ mb: 2 }}>
          Successfully deleted {connectionDeleteName.name} catalog
        </Alert>
      )}
      {showSuccessMessage && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {`${location.state.successMessage}${location.state.connectionName} catalog`}
        </Alert>
      )}
      {loading && (
        <div className="overlay">
          <div className="loading-container">
            <Spinner />
            <p className="please-wait">Please wait...</p>
          </div>
        </div>
      )}

      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 4,
          mt: 1,
        }}
        >

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
        <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              color: "#0a2540",
              fontFamily: "'Inter', 'Segoe UI', sans-serif",
              letterSpacing: "0.3px",
            }}
          >
            My Configurations
          </Typography>

          <InfoTip
            keyword="my_configurations"
            onLoad={(text) => {
              setDoc(text);
              setOpenDoc(true);
            }}
          />
        </div>
        <Button
          variant="contained"
          onClick={handleCreateNewConnection}
          sx={{
            backgroundColor: "#2563eb",
            color: "white",
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.95rem",
            px: 3,
            py: 1.1,
            "&:hover": {
              backgroundColor: "#1565c0",
            },
          }}
        >
          + Create New Configuration
        </Button>
        </Box>

        <input
        type="text"
        placeholder="Search files..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: '20%',
          padding: '0.5rem',
          marginBottom: '1rem',
          fontSize: '1rem'
        }}
      />
      {/* Connections List */}
      {filteredConnections.length === 0 ? (
        <Typography
          variant="body1"
          sx={{ textAlign: "center", color: "#64748b", mt: 4 }}
        >
          No configurations created yet.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {filteredConnections.map((connection, index) => (
            <Grid item xs={12} md={6} key={connection.id}>
              <Box
                sx={{
                  borderRadius: 2,
                  border: "1px solid #e2e8f0",
                  p: 3,
                  backgroundColor: "#ffffff",
                  transition: "border-color 0.2s ease, background-color 0.2s ease",
                  "&:hover": {
                    borderColor: "#1976d2",
                    backgroundColor: "#f8fbff",
                  },
                }}
              >
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#0a2540" }}>
                  {connection.name}
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: "#64748b" }}>
                  Feature: {connection.feature}
                </Typography>

                <Stack direction="row" spacing={1.5}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() =>
                      handleEditConnection(connection.name, connection.feature)
                    }
                    sx={{
                      backgroundColor: "#2563eb",
                      fontWeight: 500,
                      color: "#fff",
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#1565c0",
                      },
                    }}
                  >
                    Edit
                  </Button>

                  <Button
                    variant="outlined"
                    color="error"
                    size="small"
                    onClick={(e) => {
                      e.preventDefault();

                      Swal.fire({
                        title: 'Confirm Delete',
                        text: `Are you sure you want to delete ${connection.name}?`,
                        icon: 'warning',
                        background: '#ccc',
                        color: '#000',
                        iconColor: '#d32f2f',
                        confirmButtonText: 'Delete',
                        confirmButtonColor: '#d32f2f',
                        cancelButtonText: 'Cancel',
                        cancelButtonColor: '#f5c518',
                        showCancelButton: true,
                      }).then((result) => {
                        if (result.isConfirmed)
                          handleDelete("", "config", connection, index);
                      });


                    }}
                    sx={{
                      borderRadius: "6px",
                      borderColor: "#e53935",
                      color: "#d32f2f",
                      fontWeight: 500,
                      textTransform: "none",
                      "&:hover": {
                        backgroundColor: "#fdecea",
                        borderColor: "#d32f2f",
                      },
                    }}
                  >
                    Delete
                  </Button>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  </Box>

  <Drawer
  anchor="right"
  open={openDoc}
  onClose={() => setOpenDoc(false)}
>

  <div
    style={{
      width: "420px",
      height: "100%",
      display: "flex",
      flexDirection: "column"
    }}
  >

    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "12px 16px",
        borderBottom: "1px solid #ddd"
      }}
    >

      <strong>How to use features on this page?</strong>

      <IconButton onClick={() => setOpenDoc(false)}>
        <CloseIcon />
      </IconButton>

    </div>

    {/* Markdown Content */}
    <div
      style={{
        padding: "20px",
        overflowY: "auto",
        flex: 1
      }}
    >
      <ReactMarkdown
  components={{
    img: ({ node, ...props }) => (
      <img
        src={`/docs/${props.src}`}
        alt={props.alt}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          marginTop: "12px",
        }}
      />
    ),
  }}
>
  {doc}
</ReactMarkdown>
    </div>

  </div>

</Drawer>

</div>

  );
}

export default ListConnectionPage;
